import { CircularProgress, styled } from "@material-ui/core";

export const Loading = styled(CircularProgress)({
  alignSelf: 'center',
  width: '20px',
});

